import { Link } from "react-router-dom";

interface WorkLike {
  id: number;
  title: string;
  type: string;
  year: number;
  status: string;
  cover: string;
  rating: number;
}

interface WorkCardProps {
  work: WorkLike;
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full h-72 overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={work.title}
          title={`${work.title} - 大岛优香影视作品`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-background-50/95 text-primary-700 text-xs font-medium">
          {work.type}
        </span>
        <span
          className={`absolute top-3 right-3 px-2 py-0.5 rounded-full text-xs font-medium ${
            work.status === "上映"
              ? "bg-primary-500 text-background-50"
              : "bg-accent-500 text-background-50"
          }`}
        >
          {work.status}
        </span>
      </div>
      <div className="p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {work.title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{work.year}</span>
          <span className="flex items-center gap-1 text-secondary-700">
            <i className="ri-star-fill text-primary-500 w-3.5 h-3.5 flex items-center justify-center" />
            {work.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}